import { render, staticRenderFns } from "./NegativeSentimentDataModal.vue?vue&type=template&id=06940f77&scoped=true&"
import script from "./NegativeSentimentDataModal.vue?vue&type=script&lang=js&"
export * from "./NegativeSentimentDataModal.vue?vue&type=script&lang=js&"
import style0 from "./NegativeSentimentDataModal.vue?vue&type=style&index=0&id=06940f77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06940f77",
  null
  
)

export default component.exports